import React from 'react';
import CrudManager from './CrudManager';
import { adminApi } from '../../lib/api';

const GALLERY_FIELDS = [
  {
    name: 'category',
    label: 'Category',
    type: 'select',
    required: true,
    placeholder: 'Select category',
    options: [
      { value: 'Weddings', label: 'Weddings' },
      { value: 'Birthdays', label: 'Birthdays' },
      { value: 'Corporate', label: 'Corporate' },
      { value: 'Glam Booth', label: 'Glam Booth' },
      { value: 'Engagements', label: 'Engagements' },
      { value: 'Events', label: 'Events' },
    ],
  },
  {
    name: 'image',
    label: 'Image URL',
    required: true,
    placeholder: 'https://...',
    help: 'Paste the image URL (Unsplash, your CDN, or any public URL)',
  },
  { name: 'alt', label: 'Alt Text', placeholder: 'Description of the image' },
  { name: 'order', label: 'Display Order', type: 'number' },
];

const GalleryAdmin = () => (
  <CrudManager
    title="Gallery"
    description="Featured gallery images on the homepage"
    api={adminApi.gallery}
    fields={GALLERY_FIELDS}
    itemLabel="Image"
    groupBy="category"
    renderItem={(item) => (
      <div className="flex gap-4 items-start">
        <img
          src={item.image}
          alt={item.alt}
          className="w-20 h-20 object-cover rounded flex-shrink-0"
        />
        <div className="flex-1 min-w-0">
          <p className="text-[#EADBC8] font-medium mb-1">{item.alt || 'No description'}</p>
          <p className="text-gray-400 text-xs truncate">{item.image}</p>
          <p className="text-gray-500 text-xs mt-1">Order: {item.order}</p>
        </div>
      </div>
    )}
  />
);

export default GalleryAdmin;
